import {
  AddedToBagContainer,
  useAddedToBagContextStore,
} from "./AddedToBagStore";

export const useAddedToBag = () => {
  const [{ shouldIgnore, ignoredContainers }, setAddToBagContextStore] =
    useAddedToBagContextStore(["shouldIgnore", "ignoredContainers"]);

  const ignoreContainer = (container: AddedToBagContainer, ignore: boolean) => {
    const newIgnoredContainers = { ...ignoredContainers, [container]: ignore };

    if (ignoredContainers[container] !== ignore) {
      setAddToBagContextStore({
        ignoredContainers: newIgnoredContainers,
      });
    }
    setAddToBagContextStore({
      shouldIgnore:
        ignore || Object.values(newIgnoredContainers).some((value) => value),
    });
  };

  return { shouldIgnore, ignoreContainer };
};
